import { useEffect, useState } from "react";
import { AlertTriangle, ArrowRight, Info } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Spinner } from "@/components/common";
import { Button } from "@/components/ui/button";
import { LEVEL_STYLE } from "@/pages/admin/privacy/shared";

const COUNTS = [["rights_open", "Open requests"], ["rights_overdue", "Overdue requests"], ["breaches_open", "Open breaches"], ["dpias_pending", "DPIAs pending"], ["transfers_unconfirmed", "Transfers to confirm"], ["deletions", "Accounts deleted"]];

export const Overview = ({ go }) => {
  const [d, setD] = useState(null);
  const load = () => api.get("/admin/privacy/alerts").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  if (!d) return <Spinner />;
  const runRetention = async () => { try { const { data } = await api.post("/admin/privacy/retention/run"); toast.success(`Retention run: ${data.activity_events} old activity events removed`); load(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="space-y-6" data-testid="privacy-overview">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
        {COUNTS.map(([k, l]) => <div key={k} className="surface p-4" data-testid={`privacy-count-${k}`}><p className="font-serif text-3xl">{d.counts[k]}</p><p className="text-xs text-slate-500">{l}</p></div>)}
      </div>
      <section className="space-y-2"><h2 className="text-2xl">Needs attention</h2>
        {d.items.length === 0 ? <p className="text-sm text-slate-500" data-testid="privacy-alerts-empty">Nothing needs attention.</p> : (
          <ul className="space-y-2" data-testid="privacy-alerts">{d.items.map((a, i) => (
            <li key={i}><button onClick={() => go(a.tab)} data-testid={`privacy-alert-${i}`} className={`flex w-full items-center gap-3 rounded-xl border px-4 py-3 text-left text-sm transition-transform hover:-translate-y-0.5 ${LEVEL_STYLE[a.level]}`}>
              {a.level === "info" ? <Info size={16} /> : <AlertTriangle size={16} />}<span className="flex-1">{a.text}</span><ArrowRight size={15} /></button></li>))}</ul>)}
      </section>
      <section className="surface flex flex-wrap items-center gap-3 p-5"><div className="flex-1"><p className="font-medium">Retention</p>
        <p className="text-xs text-slate-500" data-testid="retention-last-run">Activity events older than 90 days are removed and expired exports closed. Runs on every server start. Last run: {d.retention_last_run ? fmtDate(d.retention_last_run.at) : "never"}.</p></div>
        <Button variant="outline" className="rounded-full" onClick={runRetention} data-testid="retention-run-btn">Run retention now</Button></section>
    </div>
  );
};
